module.exports = __webpack_public_path__ + "static/Irriglobe_Corpo-bdfe9e4ca046e3491dcbfdc3fba44a49.mp4";